import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Account } from "@app/models/account";
import { AccountType } from "@app/models/account-type";
import { AccountService } from "@app/services/account.service";
import { GlobalErrorHandlerService } from "@app/services/global-error-handler.service";
import { NotificationService } from "@app/services/notification.service";
import { OffBalanceAccountService } from '@app/services/off-balance-account.service';
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    selector: 'app-user-account-list-node',
    templateUrl: './user-account-list-node.component.html',
    styleUrls: ['./user-account-list-node.component.css'],
    standalone: false
})
export class UserAccountListNodeComponent implements OnInit {

  @Input() selectedAccount: any;
  @Input() hideClosedAccount: boolean;
  @Input() loadAccount: boolean;
  @Input() allowSelectAccountType: boolean;
  @Input() isForeignCurrencyAccount: boolean;
  @Input() accountTypes: Array<AccountType>;
  @Input() currency: string;
  @Input() level: number;
  @Input() maxLevel: number;
  @Output() addAccountType = new EventEmitter<AccountType>();
  @Output() addAccount = new EventEmitter<Account>();
  @Output() deleteAccountFromList = new EventEmitter();

  accounts: Object;

  errorMessage: string | boolean;
  infoMessage: string;
  pageSize: number = 9999;
  pageIndex: number = 0;
  open: boolean = true;

  modalRef: BsModalRef;

  defaultPageParams = {
    size: 10000,
    page: 0
  }

  constructor(
    private errorService: GlobalErrorHandlerService,
    private notificationService: NotificationService,
    private accountService: AccountService,
    private offBalanceAccountService: OffBalanceAccountService
  ) { }

  ngOnInit(): void {
    this.accounts = {};
  }

  getAccountsByGL(accountType: any, needToUpdate: boolean) {
    if (needToUpdate && this.loadAccount && accountType) {
      let code = accountType.code;
      this.accounts[code] = []
      if (code && this.level > 1) {
        const pageOption = {
          size: this.pageSize,
          page: this.pageIndex,
          accountTypeCode: code
        };
        
        const filters: any = { ...this.defaultPageParams, ...pageOption };
        if (this.currency) {
          filters.currency = this.currency;
        }
        
        const pageParams = filters;
        if (this.isGlOffBalance(accountType)) {
          this.offBalanceAccountService.getList(pageParams).subscribe({
            next: (data) => {
              data.content.sort((a, b) => {
                return new Date(b.created).valueOf() - new Date(a.created).valueOf();
              });
              this.accounts[code] = data.content;
              if (this.hideClosedAccount) {
                this.accounts[code] = this.accounts[code].filter(p => p.status == "ACTIVE");
              }
            },
            error: (err) => {
              this.errorMessage = this.errorService.handleError(err);
              this.notificationService.showErrorMessage(`${this.errorMessage}`);
            }
          });
        } else {
        this.accountService.getList(pageParams).subscribe({
          next: (data) => {
            this.accounts[code] = data.content.filter(p => p.accountType.enabled);
            if (this.isForeignCurrencyAccount) {
              this.accounts[code] = this.accounts[code].filter(p => !p.currency?.default);
            }
            if (this.hideClosedAccount) {
              this.accounts[code] = this.accounts[code].filter(p => p.status == "ACTIVE");
            }
          },
          error: (err) => {
            this.errorMessage = this.errorService.handleError(err);
            if(this.errorMessage)
                this.notificationService.showErrorMessage(`${this.errorMessage}`);
          }
          });
        }
      }
    }
  }

  composeAccountType(accountType: AccountType) {
    this.addAccountTypeItem(accountType);
  }

  changeAccountTypeStatus(accountType: AccountType, event) {
    if (event.target.checked) {
      this.composeAccountType(accountType)
    } else {
      this.removeAccount();
      this.accountService.selectedAccount = null;
    }
  }

  addAccountTypeItem(accountType: AccountType) {
    if (this.addAccountType) {
      this.addAccountType.emit(accountType);
    }
  }

  composeAccounts(account: Account) {
    if (account) {
      this.addAccountItem(account);
    }
  }

  addAccountItem(item: Account) {
    this.addAccount.emit(item);
  }

  getSelectedAccount() {
    return this.accountService.selectedAccount
  }

  changeAccountStatus(event, account) {
    if (event.target.checked) {
      this.composeAccounts(account)
    } else {
      this.removeAccount();
      this.accountService.selectedAccount = null;
    }
  }

  removeAccount() {
    this.deleteAccountFromList.emit()
  }

  isGlOffBalance(glAccount) {
    if (glAccount && glAccount.glAccountType.toString() == 'OFF_BALANCE') {
      return true;
    }
    return false;
  }

}
